import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import { STUDENT_CONST } from '../../auth/login/LoginReducer';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allUsuProfesionesAction,
  setActivoUsuProfesionesAction,
} from './UsuProfesionesAction';
import FormUsuProfesiones from './components/FormUsuProfesiones';
import ListadoUsuProfesiones from './components/ListadoUsuProfesiones';

const UsuProfesionesView = () => {
  const dispatch = Redux.useDispatch();

  const usuEntidadesStore = Redux.useSelector((state) => state.usuEntidades);
  const usuProfesionesStore = Redux.useSelector(
    (state) => state.usuProfesiones,
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  const isStudent = usuEntidadesStore.activo.usuario.rol === STUDENT_CONST;

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {isStudent ? null : (
          <BotonComponent
            click={async () => {
              await setActivoUsuProfesionesAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            mr={2}
            addIcon
          />
        )}
        <BotonComponent
          click={async () => {
            await setActivoUsuProfesionesAction(dispatch, null);
            await allUsuProfesionesAction(dispatch, usuProfesionesStore.params);
          }}
          disabled={
            usuProfesionesStore.all.length === 0 ||
            usuProfesionesStore.loadingAll
          }
          white
          refreshIcon
          text={
            usuProfesionesStore.loadingAll ? 'Actualizando...' : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={12}>
        <ListadoUsuProfesiones
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </Grid>
      <ModalComponent
        id="modalFormUsuProfesiones"
        maxWidth="sm"
        title={`${
          usuProfesionesStore.activo
            ? `Editar profesión: ${usuProfesionesStore.activo.profesion.nombre}`
            : 'Asignar profesión'
        }`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormUsuProfesiones
          activo={usuProfesionesStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default UsuProfesionesView;
